import { HTMLAttributes } from "react"

import { IconProps } from "../../../../components/Icon"
import { classNames } from "../../../../lib/classNames"

export const IconSizes = {
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
  ExtraLarge: "xl",
  ExtraExtraLarge: "xxl",
} as const
export type IconSize = (typeof IconSizes)[keyof typeof IconSizes]

export interface LucideIconProps extends HTMLAttributes<HTMLDivElement> {
  wrapperSize?: IconSize
  iconSize?: IconSize
  Icon: IconProps["icon"]
  className?: string
}

export function LucideIconComponent({
  iconSize = IconSizes.Medium,
  wrapperSize,
  Icon,
  className,
  ...otherProps
}: LucideIconProps) {
  const extraSmallClassName = "h-3 w-3"
  const smallClassName = "h-4 w-4"
  const mediumClassName = "h-5 w-5"
  const largeClassName = "h-6 w-6"
  const extraLargeClassName = "h-8 w-8"
  const extraExtraLargeClassName = "h-16 w-16"
  const classBySize: Record<IconSize, string> = {
    [IconSizes.ExtraSmall]: extraSmallClassName,
    [IconSizes.Small]: smallClassName,
    [IconSizes.Medium]: mediumClassName,
    [IconSizes.Large]: largeClassName,
    [IconSizes.ExtraLarge]: extraLargeClassName,
    [IconSizes.ExtraExtraLarge]: extraExtraLargeClassName,
  }

  if (!Icon) {
    return null
  }

  return (
    <div
      className={classNames(
        classBySize[wrapperSize ?? iconSize],
        "flex items-center justify-center",
        className
      )}
      {...otherProps}
    >
      <Icon className={classBySize[iconSize]} />
    </div>
  )
}
